import * as React from 'react';

export default function EnterpriseDesktopLoggedInMainNav() {
  return <div>EnterpriseDesktopLoggedInMainNav</div>;
}
